import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import {
  columnCompletedOn,
  columnCreatedOn,
  columnDataOwners,
  columnDatasetLink,
  columnMultiSelect,
  columnNameLink,
  columnProject,
  columnStatus,
  columnTools,
  columnWorkspaceNameLink,
} from '@/constants/fields';
import urls, { codeUrl } from '@/constants/urls';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import RequestsTableRows from '../containers/RequestsTableRows';
import RequestsFilters from '../containers/RequestsFilters';
import RequestsTableSettingsMenu from './RequestsTableSettingsMenu';
import RequestsTableHeader from './RequestsTableHeader';

const RequestsTable = ({
  canCreate,
  category,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnDataOwners,
    columnProject,
    columnDatasetLink,
    columnCreatedOn,
    columnCompletedOn,
    columnStatus,
    columnWorkspaceNameLink,
    columnTools,
  ],
  currentPage,
  fetchData,
  hideColumns,
  newRequestCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  requests,
  total,
}) => {
  const { items, pageNumber } = fitToPage(requests, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-requests-table" columns={columns}>
        <RequestsTableHeader
          category={category}
          columns={columns}
          hideColumns={hideColumns}
          requests={items}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          {readStatus === states.SUCCESS && !hideColumns && (<RequestsTableSettingsMenu category={category} />)}
          <RequestsFilters category={category} className="aridhia-table-filter" />
        </RequestsTableHeader>
        <Table.Body>
          <RequestsTableRows category={category} items={items} columns={columns} onCheckBoxClick={onCheckBoxClick} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="request"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="key"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={codeUrl(urls.REQUEST, newRequestCode, '#')}
      />
    </div>
  );
};

export default RequestsTable;
